export default {
	GET_CHART_DATA: '/workflow-service/process-instances/field-chart-data'
};
